module.exports = __webpack_public_path__ + "img/logo_spaceapps-300x150.fea10c2e.png";